import ModalReward from "./ModalReward";
export default ModalReward;
